import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getFormBundlesAction } from 'store/forms/actions';

/**
 * Upload Form Delivery resolves its document type from the loaded form bundles, which only the
 * loan editor loads; standalone hosts load them when the task action needs them.
 * @param {{ isEnabled: boolean }} params
 * @returns {boolean} whether the bundles are ready (always true when not needed)
 */
const useTaskActionFormBundles = ({ isEnabled }) => {
  const dispatch = useDispatch();
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    if (!isEnabled) {
      return;
    }

    Promise.resolve(dispatch(getFormBundlesAction({ includeElements: true })))
      .catch(Error)
      .finally(() => setIsLoaded(true));
  }, [dispatch, isEnabled]);

  return !isEnabled || isLoaded;
};

export default useTaskActionFormBundles;
